// extracted by mini-css-extract-plugin
export default {"wrapper":"l2-z","play":"m2-z"};